import AspectRatio from '@mui/icons-material/AspectRatio';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '@/util/Configuracao';
import ReactComponent from '../ReactComponent';
import TextFieldSecretaria from '../TextFieldSecretaria';

class ComplementoAnotacao extends ReactComponent {
    anotacoes = '';
    openDialog = false;
    timeoutSalvar;
    static QTD_MAXIMA_CARACTERES = Configuracao.QTD_MAXIMA_CARACTERES_TEXTO_PADRAO;

    constructor(props) {
        super(props);

        makeObservable(this, {
            anotacoes: observable,
            openDialog: observable,
            registro: computed,
            processo: computed,
            handleChangeAnotacoes: action,
            abrirPopupAnotacoes: action,
            handleCloseDialog: action
        });

        this.createReaction(
            reaction(
                () => this.registro,
                (registro) => {
                    let complemento = registro ? registro.informacaoProcessoSalaSessao.complementoAnotacoes : undefined;
                    this.anotacoes = complemento ? complemento : '';
                }
            )
        );
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    componentDidMount() {
        if (this.registro) {
            let complemento = this.registro.informacaoProcessoSalaSessao.complementoAnotacoes;
            runInAction(() => (this.anotacoes = complemento ? complemento : ''));
        }
    }

    handleChangeAnotacoes = (value) => {
        this.anotacoes = value;
    };

    salvarComplementoAnotacao = (anotacoes) => {
        this.salaSessaoStore.salvarComplementoAnotacao(this.registro, anotacoes).then(() => {
            runInAction(() => {
                this.registro.informacaoProcessoSalaSessao.complementoAnotacoes = anotacoes;
            });
            this.salaSessaoStore.ordenarProcessos();
        });
    };

    abrirPopupAnotacoes = () => {
        if (this.observableProps.onOpenAnotacoesInformacoesProcesso) {
            this.observableProps.onOpenAnotacoesInformacoesProcesso();
        } else {
            this.openDialog = true;
        }
    };

    handleCloseDialog = () => {
        this.openDialog = false;
    };

    render() {
        const larguraTotal = this.observableProps.larguraTotal ? { width: '100%' } : {};
        return (
            <div style={{ display: 'flex', marginTop: '10px', ...larguraTotal }}>
                <TextFieldSecretaria
                    disabled={this.observableProps.desabilitado || this.registro.necessitaImportacaoSalaSessao}
                    label="Anotações"
                    multiline={true}
                    minRows={2}
                    maxRows={2}
                    value={this.anotacoes}
                    onChange={this.handleChangeAnotacoes}
                    salvar={this.salvarComplementoAnotacao}
                    inputProps={{ maxLength: ComplementoAnotacao.QTD_MAXIMA_CARACTERES }}
                />
                <div
                    style={{
                        fontSize: '12px',
                        marginLeft: '5px',
                        position: 'relative',
                        width: '70px',
                        textAlign: 'center'
                    }}
                >
                    <Tooltip title={'Expandir anotações'}>
                        <AspectRatio
                            onClick={this.abrirPopupAnotacoes}
                            style={{ cursor: 'pointer', marginTop: '10px', width: '50px' }}
                        />
                    </Tooltip>
                    {this.registro.necessitaImportacaoSalaSessao ? (
                        <div></div>
                    ) : (
                        <Dialog
                            open={this.openDialog}
                            onClose={this.handleCloseDialog}
                            maxWidth="lg"
                            style={{ minHeight: '400px' }}
                        >
                            <DialogTitle>Anotação</DialogTitle>
                            <DialogContent>
                                <TextFieldSecretaria
                                    style={{ display: 'flex', marginTop: '10px', width: '1000px' }}
                                    disabled={
                                        this.observableProps.desabilitado || this.registro.necessitaImportacaoSalaSessao
                                    }
                                    multiline={true}
                                    minRows={20}
                                    maxRows={20}
                                    value={this.anotacoes}
                                    onChange={this.handleChangeAnotacoes}
                                    salvar={this.salvarComplementoAnotacao}
                                    inputProps={{ maxLength: ComplementoAnotacao.QTD_MAXIMA_CARACTERES }}
                                />
                                <Typography
                                    sx={{ textAlign: 'right' }}
                                >{`${this.anotacoes.length} / ${ComplementoAnotacao.QTD_MAXIMA_CARACTERES}`}</Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={this.handleCloseDialog}
                                    color="primary"
                                    variant="contained"
                                    endIcon={<CloseIcon />}
                                >
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                    <p
                        style={{ position: 'relative', bottom: '-10px' }}
                    >{`${this.anotacoes.length} / ${ComplementoAnotacao.QTD_MAXIMA_CARACTERES}`}</p>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(ComplementoAnotacao));
